import { styled } from '@mui/material';
import ReactFlagsSelect from "react-flags-select";
import Typography from "../typography/typography";
import images from "../../assets/images";

interface ICountrySelect {
  country: string;
  handleCountry: (country: string) => void;
}

const StyledFlagsSelect = styled(ReactFlagsSelect)(
  ({ theme: { palette } }) => ({
    ".country-button": {
      span: {
        fontSize: "0.875rem",
      },
      svg: {
        fontSize: "1.25rem",
      },
      padding: "0.2rem 0.5rem 0.2rem 0rem",
      borderRadius: ".25rem",
      border: "1px solid #D3D3D4",
    },

    ul: {
      input: {
        padding: "0.5rem",
        borderRadius: "0.5rem",
        fontSize: "0.8125rem",
        margin: "0px 0.75rem",
        border: `1px solid ${palette.theme?.secondary[200]}`,
        background: `url(${images.search}) no-repeat scroll 0.5rem 0.5rem`,
        paddingLeft: "2rem",
        backgroundRepeat: "no-repeat",
        backgroundColor: `${palette.theme?.secondary[100]}`,
      },
      li: {
        fontSize: "0.8125rem",
        padding: "0.5rem 1rem",
      },
      boxShadow:
        "0px 0px 2px 0px #E0E0E0, 0px 1px 4px -2px rgba(24, 39, 75, 0.02), 0px 4px 4px -2px rgba(24, 39, 75, 0.06)",
      borderRadius: "0.5rem",
      marginTop: "0.25rem",
      border: "none",

      div: {
        borderBottom: `1px solid ${palette.theme?.secondary[200]}`,
        paddingBottom: "0.5rem",
      },
    },
  }),
);

const CountrySelect = ({ country, handleCountry }: ICountrySelect) => {
  return (
    <>
      <Typography type="s4" fontWeight={"medium"} mb={0.5}>
        Country
      </Typography>
      <StyledFlagsSelect
        fullWidth
        searchable={true}
        searchPlaceholder="Search Country"
        selected={country || "IN"}
        selectButtonClassName="country-button"
        onSelect={handleCountry}
        showSelectedLabel={true}
      />
    </>
  );
};

export { CountrySelect };
export default CountrySelect;
